import React, { useState } from 'react';
import { connect } from 'react-redux';
import { IonButton, IonCard, IonCardHeader, IonCol, IonContent, IonGrid, IonIcon, IonInput, IonItem, IonLabel, IonRow, IonSelect, IonSelectOption, IonText, IonTitle } from '@ionic/react';
import { checkmarkCircleOutline, closeCircleOutline } from 'ionicons/icons';

import { GetABMIntern } from '../../store/ABMMetric/ABMIntern/ABMInternActions';

import ApiRequestor from '../../api_access/ApiRequestor';

import './ABMMetric.css';
import Modal from '../Modal/Modal';

interface InternMetric {
    intern_id: number;
    intern_name: string;
    intern_host: string;
    intern_field: string;
    intern_type: string;
    intern_transform: boolean;
    intern_endpoint_id: string;
    intern_threshold: boolean;
    intern_title: string;
    intern_title_key: string;
    intern_time_gap: number;
    intern_linechart_label: string;
    intern_category: string;
    intern_graphic: boolean;
    intern_created_by: string,
    intern_updated_by: string
}

interface Props extends StateTypes, dispatchTypes {
    internData: InternMetric
    backToTable: () => void;
    service_name: string;
}

const ModifyABMIntern: React.FC<Props> = (props): JSX.Element => {

    const [internDataModify, setInternDataModify] = useState({
        intern_name: props.internData.intern_name,
        intern_host: props.internData.intern_host,
        intern_field: props.internData.intern_field,
        intern_type: props.internData.intern_type,
        intern_transform: props.internData.intern_transform,
        intern_endpoint_id: props.internData.intern_endpoint_id,
        intern_title: props.internData.intern_title,
        intern_title_key: props.internData.intern_title_key,
        intern_time_gap: props.internData.intern_time_gap,
        intern_linechart_label: props.internData.intern_linechart_label,
        intern_graphic: props.internData.intern_graphic,
        intern_category: props.internData.intern_category
    })
    const [showModalAdd, setShowModalAdd] = useState(false);
    const [errors, setErrors] = useState({intern_name: '', intern_host: '', intern_field: '',
        intern_title: '', intern_title_key: '', intern_time_gap:'', intern_linechart_label: ''
        })
    const nameRegex = /^[a-zA-ZáéíóúÁÉÍÓÚñÑ0-9_%()\-]+(\s[a-zA-ZáéíóúÁÉÍÓÚñÑ0-9_%()\-]+)*$/;
    const regularExpresionLegend = /^[^\s].*[^\s]$|^$/;
    const numRegex = /^\d+$/;

    const saveData = (e: any) => {
        setInternDataModify({
            ...internDataModify,
            [e.target.name]: e.detail.value!
        })
    }

    const validateForm = () => {

        const isEmpty = (value: any) => !value.trim();
        const isInvalidText = (value: any) => !nameRegex.test(value);
        const isInvalidNumber = (value: any) => !numRegex.test(value);
        const isInvalidLegend = (value: any) => !regularExpresionLegend.test(value);

        const errors = {
            intern_name: isEmpty(internDataModify.intern_name)
            ? 'El campo "Nombre" no debe ser vacío'
            : isInvalidText(internDataModify.intern_name)
            ? 'No se permiten espacios al inicio o al final'
            : '',
            intern_host: isEmpty(internDataModify.intern_host)
            ? 'El campo "Host" no debe ser vacío'
            : isInvalidText(internDataModify.intern_host)
            ? 'No se permiten espacios al inicio o al final'
            : '',
            intern_field: isEmpty(internDataModify.intern_field)
            ? 'El campo "Campo" no debe ser vacío'
            : isInvalidText(internDataModify.intern_field)
            ? 'No se permiten espacios al inicio o al final'
            : '',
            intern_title: isEmpty(internDataModify.intern_title)
            ? 'El campo "Titulo" no debe ser vacío'
            : isInvalidText(internDataModify.intern_title)
            ? 'No se permiten espacios al inicio o al final'
            : '',
            intern_title_key: isEmpty(internDataModify.intern_title_key)
            ? 'El campo "Key Titulo" no debe ser vacío'
            : isInvalidText(internDataModify.intern_title_key)
            ? 'No se permiten espacios al inicio o al final'
            : '',
            intern_time_gap: isInvalidNumber(internDataModify.intern_time_gap)
            ? 'Debe ingresar al menos un número'
            : '',
            intern_linechart_label: isInvalidLegend(internDataModify.intern_linechart_label)
            ? 'No se permiten espacios al inicio o al final'
            : ''
        }

        setErrors(errors as any);
        const hasErrors = Object.values(errors).some(error => error !== '');

        return hasErrors;
    }

    const modifyIntern = async () => {

        validateForm();

        let valid = validateForm();

        if (!valid) {

            let data: any = {
                body: {
                    intern_id: props.internData.intern_id,
                    intern_name: internDataModify.intern_name,
                    intern_host: internDataModify.intern_host,
                    intern_field: internDataModify.intern_field,
                    intern_type: internDataModify.intern_type,
                    intern_transform: internDataModify.intern_transform,
                    intern_threshold: props.internData.intern_threshold,
                    intern_title: internDataModify.intern_title,
                    intern_title_key: internDataModify.intern_title_key,
                    intern_time_gap: Number(internDataModify.intern_time_gap),
                    intern_linechart_label: internDataModify.intern_linechart_label,
                    intern_category: internDataModify.intern_category,
                    intern_graphic: internDataModify.intern_graphic,
                }
            }

            const response = await ApiRequestor.requestToApi('/swt-admin/intern', 'PUT', data)
            if (response && response.status === 200) {
                props.getSeeABMIntern()
                setShowModalAdd(true)
            }
        } else {
            validateForm()
        }
    }

    const onDismissModal = () => {
        setShowModalAdd(false)
        props.backToTable()
    }

    return (
        <div className="custom-content-scroll">
            <IonCard className="ABMKpisCardForm">
                <IonCardHeader>
                    <IonTitle className="ABMKpisTitleKpi">MODIFICACIÓN DE MÉTRICA</IonTitle>
                </IonCardHeader>
                <IonGrid className='ABMKpisADD'>
                    <IonRow>
                        <IonCol sizeXl="6" sizeXs='12'>
                            <IonLabel className="ABMKpisLabelKpis">Cliente</IonLabel>
                            <IonItem lines='none'>
                                <IonInput
                                    className="ABMKpisInputKpis"
                                    type="text"
                                    placeholder="Cliente"
                                    value={props.service_name}
                                    disabled />
                            </IonItem>
                        </IonCol>
                        <IonCol sizeXl="6" sizeXs='12'>
                            <IonLabel className="ABMKpisLabelKpis">Nombre</IonLabel>
                            <IonItem lines='none'>
                                <IonInput
                                    className="ABMKpisInputKpis"
                                    type="text"
                                    name='intern_name'
                                    placeholder="Nombre"
                                    value={internDataModify.intern_name}
                                    onIonChange={(e) => saveData(e)} />
                            </IonItem>
                            <IonText>
                                <p className={errors.intern_name ? "login-valid-text" : "ion-hide"}>{errors.intern_name}</p>
                            </IonText>
                        </IonCol>
                    </IonRow>
                    <IonRow>
                        <IonCol sizeXl="6" sizeXs='12'>
                            <IonLabel className="ABMKpisLabelKpis">Host</IonLabel>
                            <IonItem lines='none'>
                                <IonInput
                                    className="ABMKpisInputKpis"
                                    type="text"
                                    name='intern_host'
                                    placeholder="Host"
                                    value={internDataModify.intern_host}
                                    onIonChange={(e) => saveData(e)} />
                            </IonItem>
                            <IonText>
                                <p className={errors.intern_host ? "login-valid-text" : "ion-hide"}>{errors.intern_host}</p>
                            </IonText>
                        </IonCol>
                        <IonCol sizeXl="6" sizeXs='12'>
                            <IonLabel className="ABMKpisLabelKpis">Título</IonLabel>
                            <IonItem lines='none'>
                                <IonInput
                                    className="ABMKpisInputKpis"
                                    type="text"
                                    name='intern_title'
                                    placeholder="Título"
                                    value={internDataModify.intern_title}
                                    onIonChange={(e) => saveData(e)} />
                            </IonItem>
                            <IonText>
                                <p className={errors.intern_title ? "login-valid-text" : "ion-hide"}>{errors.intern_title}</p>
                            </IonText>
                        </IonCol>
                    </IonRow>
                    <IonRow>
                        <IonCol sizeXl="6" sizeXs='12'>
                            <IonLabel className="ABMKpisLabelKpis">Key Título</IonLabel>
                            <IonItem lines='none'>
                                <IonInput
                                    className="ABMKpisInputKpis"
                                    type="text"
                                    name='intern_title_key'
                                    placeholder="Key Título"
                                    value={internDataModify.intern_title_key}
                                    onIonChange={(e) => saveData(e)} />
                            </IonItem>
                            <IonText>
                                <p className={errors.intern_title_key ? "login-valid-text" : "ion-hide"}>{errors.intern_title_key}</p>
                            </IonText>
                        </IonCol>
                        <IonCol sizeXl="6" sizeXs='12'>
                            <IonLabel className="ABMKpisLabelKpis">Campo</IonLabel>
                            <IonItem lines='none'>
                                <IonInput
                                    className="ABMKpisInputKpis"
                                    type="text"
                                    name='intern_field'
                                    placeholder="Campo"
                                    value={internDataModify.intern_field}
                                    onIonChange={(e) => saveData(e)} />
                            </IonItem>
                            <IonText>
                                <p className={errors.intern_field ? "login-valid-text" : "ion-hide"}>{errors.intern_field}</p>
                            </IonText>
                        </IonCol>
                    </IonRow>
                    <IonRow>
                        <IonCol sizeXl="6" sizeXs='12'>
                            <IonLabel className="ABMKpisLabelKpis">Type</IonLabel>
                            <IonItem lines='none'>
                                <IonSelect
                                    interface="popover"
                                    placeholder="Seleccione el tipo"
                                    className="ABMKpisSelectKpis"
                                    name='intern_type'
                                    value={internDataModify.intern_type}
                                    onIonChange={(e) => saveData(e)}>
                                    <IonSelectOption value="QUANTITY">
                                        QUANTITY
                                    </IonSelectOption>
                                    <IonSelectOption value="PERCENTAGE">
                                        PERCENTAGE
                                    </IonSelectOption>
                                </IonSelect>
                            </IonItem>
                        </IonCol>
                        <IonCol sizeXl="6" sizeXs='12'>
                            <IonLabel className="ABMKpisLabelKpis">Transform</IonLabel>
                            <IonItem lines='none'>
                                <IonSelect
                                    interface="popover"
                                    placeholder="Seleccione"
                                    className="ABMKpisSelectKpis"
                                    name='intern_transform'
                                    value={internDataModify.intern_transform}
                                    onIonChange={(e) => saveData(e)}>
                                    <IonSelectOption value={true}>
                                        TRUE
                                    </IonSelectOption>
                                    <IonSelectOption value={false}>
                                        FALSE
                                    </IonSelectOption>
                                </IonSelect>
                            </IonItem>
                        </IonCol>
                    </IonRow>
                    <IonRow>
                        <IonCol sizeXl="6" sizeXs='12'>
                            <IonLabel className="ABMKpisLabelKpis">Endpoint</IonLabel>
                            <IonItem lines='none'>
                                <IonSelect
                                    interface="popover"
                                    placeholder="Seleccione"
                                    className="ABMKpisSelectKpis"
                                    name='intern_endpoint_id'
                                    value={internDataModify.intern_endpoint_id}
                                    onIonChange={(e) => saveData(e)}>
                                    <IonSelectOption value="prod">
                                        PROD
                                    </IonSelectOption>
                                    <IonSelectOption value="dev">
                                        DEV
                                    </IonSelectOption>
                                </IonSelect>
                            </IonItem>
                        </IonCol>
                        <IonCol sizeXl="6" sizeXs='12'>
                            <IonLabel className="ABMKpisLabelKpis">Tiempo de Recarga(min)</IonLabel>
                            <IonItem lines='none'>
                                <IonInput
                                    className="ABMKpisInputKpis"
                                    type="number"
                                    name='intern_time_gap'
                                    placeholder="Tiempo de Recarga(min)"
                                    value={internDataModify.intern_time_gap}
                                    onIonChange={(e) => saveData(e)} />
                            </IonItem>
                            <IonText>
                                <p className={errors.intern_time_gap ? "login-valid-text" : "ion-hide"}>{errors.intern_time_gap}</p>
                            </IonText>
                        </IonCol>
                    </IonRow>
                    <IonRow>
                        <IonCol sizeXl="6" sizeXs='12'>
                            <IonLabel className="ABMKpisLabelKpis">Linechart Label</IonLabel>
                            <IonItem lines='none'>
                                <IonInput
                                    className="ABMKpisInputKpis"
                                    type="text"
                                    name='intern_linechart_label'
                                    placeholder="Linechart Label"
                                    value={internDataModify.intern_linechart_label}
                                    onIonChange={(e) => saveData(e)} />
                            </IonItem>
                            <IonText>
                                <p className={errors.intern_linechart_label ? "login-valid-text" : "ion-hide"}>{errors.intern_linechart_label }</p>
                            </IonText>
                        </IonCol>
                        <IonCol sizeXl="6" sizeXs='12'>
                            <IonLabel className="ABMKpisLabelKpis">Gráfico</IonLabel>
                            <IonItem lines='none'>
                                <IonSelect
                                    interface="popover"
                                    placeholder="Seleccione"
                                    className="ABMKpisSelectKpis"
                                    name='intern_graphic'
                                    value={internDataModify.intern_graphic}
                                    onIonChange={(e) => saveData(e)}>
                                    <IonSelectOption value={true}>
                                        TRUE
                                    </IonSelectOption>
                                    <IonSelectOption value={false}>
                                        FALSE
                                    </IonSelectOption>
                                </IonSelect>
                            </IonItem>
                        </IonCol>
                    </IonRow>
                    {
                        sessionStorage.getItem("client") === "DECIDIR" &&
                        <IonRow>
                            <IonCol sizeXl="6" sizeXs='12'>
                                <IonLabel className="ABMKpisLabelKpis">Categoría</IonLabel>
                                <IonItem lines='none'>
                                    <IonSelect
                                        interface="popover"
                                        placeholder="Seleccione"
                                        className="ABMKpisSelectKpis"
                                        name='intern_category'
                                        value={internDataModify.intern_category}
                                        onIonChange={(e) => saveData(e)}>
                                        <IonSelectOption value={"GENERAL"}>
                                            GENERAL
                                        </IonSelectOption>
                                        <IonSelectOption value={"MEDIOS DE PAGO"}>
                                            MEDIOS DE PAGO
                                        </IonSelectOption>
                                        <IonSelectOption value={"COMERCIOS"}>
                                            COMERCIOS
                                        </IonSelectOption>
                                    </IonSelect>
                                </IonItem>
                            </IonCol>
                        </IonRow>
                    }
                    <IonRow className="ion-justify-content-center containerButtonKpis">
                        <IonButton type="submit" fill="clear" className='ABMKpisZoom' onClick={modifyIntern}>
                            <IonIcon icon={checkmarkCircleOutline} color="success" className="ABMKpisButton" />
                        </IonButton>
                        <IonButton fill="clear" className='ABMKpisZoom' onClick={props.backToTable}>
                            <IonIcon icon={closeCircleOutline} color="danger" className="ABMKpisButton" />
                        </IonButton>
                    </IonRow>
                </IonGrid>
            </IonCard>

            <Modal
                modalConfirmation={{
                    textConfirmation: "Métrica Modificada Correctamente",
                    onDidDimissConfirmModal: onDismissModal,
                    isOpenModalConfirm: showModalAdd,
                    onClickConfirmModal: onDismissModal,
                }}
            />

        </div>
    )

}

//Redux state and actions dispatchers

interface StateTypes {
}

const mapStatetoProps = (state: StateTypes) => {
    return {
    }
}

interface dispatchTypes {
    getSeeABMIntern: () => void;
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        getSeeABMIntern: () => dispatch(GetABMIntern())
    };
}

export default connect(mapStatetoProps, mapDispatchToProps)(ModifyABMIntern);